.stack {
  display: flex;
  flex-direction: column;
}

.gapSm {
  gap: var(--spacing-sm);
}

.gapMd {
  gap: var(--spacing-md);
}

.gapLg {
  gap: var(--spacing-lg);
}

.gapXl {
  gap: var(--spacing-2xl);
}

.gap2Xl {
  gap: var(--spacing-3xl);
}
